// export const formatCurrency = (value: number) => {
//     if (!value)
//     {
//       return "";
//     }
//     // Преобразуем число в строку и разделяем на целую и дробную части
//     const [integerPart, fractionalPart] = value.toString().split('.');
  
//     // Применяем регулярное выражение для разделения целой части на группы тысяч
//     const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  
//     // Если есть дробная часть, добавляем её обратно, если нет - возвращаем только целую часть
//     return fractionalPart ? `${formattedIntegerPart}.${fractionalPart}` : formattedIntegerPart;
//   };




  export const formatAmount = (value: number, fractionLength: number = 2): string => {
    if (value == null) {
      return "";
    }
  
    // Преобразуем число в строку и разделяем на целую и дробную части
    const [integerPart, fractionalPart = ""] = value.toString().split('.');
  
    // Применяем регулярное выражение для разделения целой части на группы тысяч
    const formattedIntegerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ' ');
  
    // Ограничиваем дробную часть до нужной длины и добавляем её обратно к целой части
    const truncatedFractionalPart = fractionalPart.slice(0, fractionLength);
    
    // Если дробная часть есть и не пустая, добавляем её к целой части
    return truncatedFractionalPart ? `${formattedIntegerPart}.${truncatedFractionalPart}` : formattedIntegerPart;
  };